import { defineComponent, ref } from "vue"; // modules

import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
export default defineComponent({
  name: "ScanSettings",
  components: {},
  setup: function setup() {
    var autoScanTickets = ref(POSConfigModule.getAutoScanTickets);

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var toggleStatus = function toggleStatus(status) {
      autoScanTickets.value = status;
    };

    return {
      autoScanTickets: autoScanTickets,
      toggleStatus: toggleStatus,
      t: t
    };
  }
});